<template>
  <Loader v-if="isLoading" />
  <div v-else>
    <template v-if="groupNameValues.length > 0">
      <label
        class="control-label col-sm-2"
      >
        {{ trans('subscription.classification_config.selectors.group.select_group') }}
      </label>
      <select
        v-model="select"
        class="form-control form-select w-75"
        @change="changeInput"
      >
        <template v-for="value in groupNameValues">
          <option
            :key="`${value.id}-${value.term}`"
            :value="{ id: value.id, term: value.term }"
          >
            {{ value.name }}
          </option>
        </template>
      </select>
    </template>
    <div v-else>
      <AdditionalExplanation :text="trans('subscription.classification_config.selectors.group.selectable_groups_explained')">
        <span
          class="fa fa-info-circle"
        />
        {{ trans('subscription.classification_config.selectors.group.no_selectable_groups') }}
      </AdditionalExplanation>
    </div>
  </div>
</template>

<script>
import Loader from '@/employees/components/Loader'
import AdditionalExplanation from '@/employees/components/AdditionalExplanation'
import { GROUP_CATEGORY } from '@/constants'
import { mapState } from 'vuex'
export default {
  name: 'SelectorConfigGroup',
  components: {
    AdditionalExplanation,
    Loader,
  },
  inject: ['selectorContext', 'programId'],
  props: {
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: null,
      isLoading: true,
    }
  },
  computed: {
    ...mapState({
      missingId (state) {
        if (this.selector?.group?.term && !state.terms.terms.hasOwnProperty(this.selector?.group?.term)) {
          return [this.term]
        }
        return []
      },
      missingTermIds (state) {
        return this.objectMissingIds(state.terms.terms, this.contextSelectorTermIds)
      },
      terms (state) {
        return state.terms.terms
      },
    }),
    contextSelectorTermIds () {
      return this.selectorContext.groupNames
        .filter(group => group?.term)
        .map(group => group.term)
    },
    groupNameValues () {
      return this.selectorContext.groupNames.map(group => {
        return {
          id: group.name,
          name: group?.term ? `${group.name} (${this.trans('core.term')} ${this.terms[group.term]?.name})` : group.name,
          term: group?.term,
        }
      }).concat([{ id: null, name: null }])
    },
  },
  watch: {
    selector: {
      handler (newValue) {
        //* This mechanism is build, because it is not clear when you can get the relevant term
        if (newValue?.group?.term) {
          this.isLoading = true
          this.getTerms()
        }
        this.isLoading = false
      },
    },
  },
  created () {
    if (this.selectorContext.groupNames.length === 0) {
      this.select = null
    }
    if (this.missingId || this.missingTermIds) {
      //* This mechanism is build, because it is not clear when you can get the relevant term
      this.isLoading = true
      this.getTerms()
      this.isLoading = false
    }
    if (this.selector?.group) {
      this.select = { id: this.selector?.group.name, term: this.selector?.group.term }
    }
  },
  methods: {
    changeInput () {
      const newValue = this.select
        ? this.groupNameValues.find(group => group.id === this.select.id && group.term === this.select.term)
        : null
      if (newValue) {
        this.$emit('input', {
          type: GROUP_CATEGORY.config,
          name: newValue.id,
          term: newValue?.term,
        })
      } else {
        this.$emit('input', null)
      }
    },
    getTerms () {
      this.$store.dispatch('getTerms', {
        queryParams: {
          filter: {
            id: this.missingId.concat(this.missingTermIds),
            programId: this.programId,
          },
        },
      })
    },
    objectMissingIds (object, idArray) {
      const missingIds = []
      for (let i = 0; i < idArray.length; i++) {
        if (!object.hasOwnProperty(idArray[i])) {
          missingIds.push(idArray[i])
        }
      }
      return missingIds
    },
  },
}
</script>

<style scoped>
/deep/
.form-control {
  width: 75%;
}
</style>
